import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-75f099fd")
const _hoisted_1 = { class: "justify-center d-flex width-full" }
const _hoisted_2 = { class: "button" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("mdi-plus")
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "ml-4 text-error text-caption" }
const _hoisted_6 = { class: "ml-4 text-error text-caption" }
_popScopeId()

import { withDefaults, ref } from 'vue'
import Action from '@/components/Dialog/enums/DialogAction'
import TheDialog from '@/components/Dialog/TheDialog.vue'
import { useField } from 'vee-validate'
import { required, validUrl } from '@/lib/validation'
import { IEnrichment } from '@/interfaces/hoppermation'

interface IProps {
  addEnrichment?: (data: IEnrichment) => void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    addEnrichment: { type: Function, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { addEnrichment: (data: IEnrichment) => void }


const action = Action.CONFIRM
const sourcePropertyPath = ref('')
const { validate: validateUrl, errorMessage: errorUrl, value: url, resetField: resetUrl } = useField('url', validUrl)
const {
  validate: validateTemplateKey,
  errorMessage: errorTemplateKey,
  value: templateKey,
  resetField: resetTemplateKey
} = useField('templateKey', required)

const onSubmit = async (): Promise<boolean> => {
  const { valid: validUrl } = await validateUrl()
  const { valid: validTemplateKey } = await validateTemplateKey()
  if (validUrl && validTemplateKey) {
    props.addEnrichment({
      url: url.value,
      templateKey: templateKey.value,
      sourcePropertyPath: sourcePropertyPath.value
    })
    resetUrl()
    resetTemplateKey()
    sourcePropertyPath.value = ''
    return true
  }
  return false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(TheDialog, {
    action: _unref(action),
    title: _ctx.$t('dialog.enrichment.title'),
    imageSrc: "https://assets8.lottiefiles.com/packages/lf20_u25cckyh.json",
    submit: onSubmit
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_icon, _mergeProps(props, {
            size: "small",
            class: "mr-5"
          }), {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 2
          }, 1040)
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("p", {
        class: "mb-4 text-subtitle",
        innerHTML: _ctx.$t('dialog.enrichment.desc')
      }, null, 8, _hoisted_4),
      _createVNode(_component_v_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: _normalizeClass(_unref(errorUrl) ? 'mb-3' : '')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        name: "url",
                        modelValue: _unref(url),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(url) ? url.value = $event : null)),
                        "persistent-hint": "",
                        label: _ctx.$t('dialog.enrichment.url.placeholder'),
                        hint: _ctx.$t('dialog.enrichment.url.hint'),
                        class: "mb-0"
                      }, null, 8, ["modelValue", "label", "hint"]),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(errorUrl) ? _ctx.$t(_unref(errorUrl)) : ''), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_row, {
                class: _normalizeClass(_unref(errorTemplateKey) ? 'mb-3' : '')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        name: "templateKey",
                        modelValue: _unref(templateKey),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(templateKey) ? templateKey.value = $event : null)),
                        "persistent-hint": "",
                        label: _ctx.$t('dialog.enrichment.templateKey.placeholder'),
                        hint: _ctx.$t('dialog.enrichment.templateKey.hint'),
                        class: "mb-0"
                      }, null, 8, ["modelValue", "label", "hint"]),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(errorTemplateKey) ? _ctx.$t(_unref(errorTemplateKey)) : ''), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "pa-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        name: "sourcePropertyPath",
                        modelValue: sourcePropertyPath.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (sourcePropertyPath.value = $event)),
                        "persistent-hint": "",
                        label: _ctx.$t('dialog.enrichment.sourcePropertyPath.placeholder'),
                        hint: _ctx.$t('dialog.enrichment.sourcePropertyPath.hint'),
                        class: "mb-0"
                      }, null, 8, ["modelValue", "label", "hint"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["action", "title"]))
}
}

})